import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { useForm } from "react-hook-form";
import { BsUpload } from "react-icons/bs";
import { MdAttachEmail } from "react-icons/md";
import swal from "sweetalert";
import ApplyByWhtsApp from "../components/applyByWhtsApp";
import Footer from "../components/footer";
import Header from "../components/header";
import TopNavabr from "../components/topNavabr";
import { BASE_URL } from "../data/baseURL";
import { useScrollTop } from "../hook/useScrollTop";
import carrerImg from "../images/carreer.jpg";

const Career = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [jobType, setJobType] = useState("Full Time");

  const handleFileChange = (e) => {
    const newFile = e.target.files[0];
    setFile(newFile);
  };

  const onHandleCV = (data, e) => {
    console.log(jobType);
    const formData = new FormData();
    formData.append("f_name", data.f_name);
    formData.append("l_name", data.l_name);
    formData.append("email", data.email);
    formData.append("phone_no", data.phone_no);
    formData.append("b_date", data.b_date);
    formData.append("about_us", data.about_us);
    formData.append("job_type", jobType);
    formData.append("job_title", data.job_title);

    if (file) {
      formData.append("file", file);
    }

    setLoading(true);

    fetch(`${BASE_URL}/add-cv`, {
      method: "POST",
      body: formData,
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.success) {
          e.target.reset();
          new FormData(e.target);
          setFile(null);
          swal("Thank You!", "For Give your Information!", "success");
          setLoading(false);
        }
      });
  };

  useScrollTop();
  return (
    <>
      <Helmet>
        <title>AFRO || Career</title>
      </Helmet>
      <TopNavabr />
      <Header bannerBackground="image" staticImageURL={carrerImg}>
        <div className="pt-7 pb-5 container">
          <div className="row header-background-image-size">
            <h1 className="fs-56 text-capitalize flex align-items-center col-12 col-md-6 gilroy-bold">
              AFRO Career Do what you love. Create the future you want.
            </h1>
            <div className="pt-5">
              <a
                href="https://www.linkedin.com/company/afrosocial247/"
                target="_blank"
                rel="noreferrer"
                className="text-uppercase fs-16 header-button text-orange-ryb fw-900 text-decoration-none d-inline-block text-center"
              >
                View Job Posts
              </a>
            </div>
          </div>
        </div>
      </Header>
      <section className="container-fluid" id="cv">
        <div className="ms-47 me-47 pt-7 pb-7">
          <div
            className="p-5"
            style={{ boxShadow: "5px 4px 22px -1px rgb(125 125 125 / 50%)" }}
          >
            <h1 className="text-center lh-40 fs-38">Create your CV Account</h1>
            <p className="text-center lh-30 fs-20">
              Get started by creating your CV Account to apply for Job
            </p>
            <hr />
            <div className="row py-5">
              <div className="col-md-8 mx-auto fs-16">
                <form onSubmit={handleSubmit(onHandleCV)}>
                  <div className="row mb-5">
                    <div className="col-md-3 my-auto">
                      <p className="gilroy-bold">Upload Your CV</p>
                    </div>
                    <div className="col-md-9">
                      <div
                        className="d-flex align-items-center justify-content-center"
                        style={{
                          height: "5rem",
                          border: " 2px dashed #BDBDBD",
                          backgroundColor: "#F4F4F4",
                          borderRadius: "3px",
                        }}
                        htmlFor="cv"
                      >
                        <label className="cursor-pointer">
                          <div className="text-center">
                            <BsUpload className="mx-auto" />
                            <span className="ms-2">Upload CV</span>
                          </div>
                          <input
                            type="file"
                            accept=".pdf"
                            id="cv"
                            name="cv"
                            className="d-none"
                            onChange={handleFileChange}
                          />
                        </label>
                      </div>
                    </div>
                  </div>

                  <div className="row mb-5">
                    <div className="col-md-3 my-auto">
                      <p className="gilroy-bold">First Name</p>
                    </div>
                    <div className="col-md-9">
                      <input
                        type="text"
                        className="w-100 py-3 px-2"
                        {...register("f_name", { required: true })}
                      />
                      {errors.f_name && (
                        <span className="text-danger ms-4">
                          *First Name Required!
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="row mb-5">
                    <div className="col-md-3 my-auto">
                      <p className="gilroy-bold">Last Name</p>
                    </div>
                    <div className="col-md-9">
                      <input
                        type="text"
                        className="w-100 py-3 px-2"
                        {...register("l_name", { required: true })}
                      />
                      {errors.l_name && (
                        <span className="text-danger ms-4">
                          *Last Name Required!
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="row mb-5">
                    <div className="col-md-3 my-auto">
                      <p className="gilroy-bold">Job Type</p>
                    </div>
                    <div className="col-md-9">
                      {/* <input
                        type="text"
                        className="w-100 py-3 px-2"
                        {...register("l_name", { required: true })}
                      />
                      {errors.l_name && (
                        <span className="text-danger ms-4">
                          *Last Name Required!
                        </span>
                      )} */}
                      <select
                        onChange={(e) => setJobType(e.target.value)}
                        className="form-select py-4 px-4 m-0"
                        style={{ border: "1px solid #000" }}
                      >
                        <option selected value="Full Time">
                          Full Time
                        </option>
                        <option value="Part Time">Part Time</option>
                        <option value="Internship((1-3 months))">
                          Internship((1-3 months))
                        </option>
                        <option value="Apprenticeship(1+ years)">
                          Apprenticeship(1+ years)
                        </option>
                        <option value="Leadership(internal Hire)">
                          Leadership(internal Hire)
                        </option>
                        <option value="Freelance (Open Training)">
                          Freelance (Open Training)
                        </option>
                      </select>
                    </div>
                  </div>

                  <div className="row mb-5">
                    <div className="col-md-3 my-auto">
                      <p className="gilroy-bold">Job Title</p>
                    </div>
                    <div className="col-md-9">
                      <input
                        type="text"
                        className="w-100 py-3 px-2"
                        {...register("job_title")}
                      />
                    </div>
                  </div>

                  <div className="row mb-5">
                    <div className="col-md-3 my-auto">
                      <p className="gilroy-bold">Email</p>
                    </div>
                    <div className="col-md-9">
                      <input
                        type="email"
                        className="w-100 py-3 px-2"
                        {...register("email", { required: true })}
                      />
                      {errors.email && (
                        <span className="text-danger ms-4">
                          *Email Required!
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="row mb-5">
                    <div className="col-md-3 my-auto">
                      <p className="gilroy-bold">Phone Number</p>
                    </div>
                    <div className="col-md-9">
                      <input
                        type="text"
                        className="w-100 py-3 px-2"
                        {...register("phone_no", { required: true })}
                      />
                      {errors.phone_no && (
                        <span className="text-danger ms-4">
                          *Phone Number Required!
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="row mb-5">
                    <div className="col-md-3 my-auto">
                      <p className="gilroy-bold">Birth Date</p>
                    </div>
                    <div className="col-md-9">
                      <input
                        type="date"
                        className="w-100 py-3 px-2"
                        {...register("b_date", { required: true })}
                      />
                      {errors.b_date && (
                        <span className="text-danger ms-4">
                          *Birth of Date Required!
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="row mb-5">
                    <div className="col-md-3">
                      <p className="gilroy-bold">How did you hear about us?</p>
                    </div>
                    <div className="col-md-9">
                      <textarea
                        className="w-100 py-3 px-2"
                        rows="6"
                        {...register("about_us", { required: true })}
                      ></textarea>
                      {errors.about_us && (
                        <span className="text-danger ms-4">*Required!</span>
                      )}
                    </div>
                  </div>

                  <div className="row mb-5">
                    <div className="col-md-3"></div>
                    <div className="col-md-9 ms-auto">
                      <button
                        type="submit"
                        name=""
                        className="w-100 py-4 px-2 bg-american-yellow border-0 text-white gilroy-bold fs-18"
                      >
                        {loading ? (
                          <>
                            <span className="me-2">Processing...</span>
                            <div
                              class="spinner-border text-light"
                              role="status"
                            >
                              <span class="visually-hidden">Loading...</span>
                            </div>
                          </>
                        ) : (
                          <span className="">
                            <MdAttachEmail className="fs-28 me-2" />
                            Apply Job
                          </span>
                        )}
                      </button>
                    </div>
                  </div>
                </form>
                <ApplyByWhtsApp />
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default Career;
